import type { ReactNode } from 'react'
import { mtc } from '@/styles'
import { ThreadView, type SendMessage } from './messages/ThreadView'

interface ThreadOverlayProps {
  activeThreadId: number | null
  onBack: () => void
  onSend?: SendMessage
  sendDisabled?: boolean
  children: ReactNode
}

export const ThreadOverlay = ({
  activeThreadId,
  onBack,
  onSend,
  sendDisabled,
  children,
}: ThreadOverlayProps) => {
  const threadOpen = activeThreadId !== null

  return (
    <div className="relative flex min-h-0 flex-1 flex-col">
      {/* invisible, not display:none, so the transcript keeps its layout box and scroll offset. */}
      <div
        className={mtc(
          'flex flex-1 flex-col overflow-hidden',
          threadOpen && 'invisible'
        )}
        aria-hidden={threadOpen}
        data-testid="thread-overlay-transcript"
      >
        {children}
      </div>
      {threadOpen && (
        <div className="absolute inset-0 flex flex-col">
          <ThreadView
            ticketId={activeThreadId}
            onBack={onBack}
            onSend={onSend}
            sendDisabled={sendDisabled}
          />
        </div>
      )}
    </div>
  )
}
